import {
  LayoutDashboard,
  Users,
  Briefcase,
  FileText,
  Calculator,
  Presentation,
  Calendar,
  Receipt,
  HardHat,
  TrendingUp,
  UserCog,
  PiggyBank,
  type LucideIcon,
} from 'lucide-react';
import type { EmployeeRole } from '../../auth/AuthContext';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  // Roles that see this item. Omitted = visible to every authenticated role.
  // This is a UI convenience only — every route/action must still be
  // authorized server-side (BUSINESS_RULES.md §16).
  roles?: EmployeeRole[];
}

// Real routes matching the v6 architecture doc §5 URL list. Business
// screens are Stage 1+ placeholders here; Stage 0 only needs the shell,
// routing, and responsive nav to exist and work end-to-end.
export const NAV_ITEMS: NavItem[] = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/customers', label: 'Customers', icon: Users, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'ESTIMATOR'] },
  { to: '/jobs', label: 'Jobs', icon: Briefcase },
  { to: '/documents', label: 'Documents', icon: FileText },
  { to: '/estimates', label: 'Estimates', icon: Calculator, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'ESTIMATOR'] },
  { to: '/presentations', label: 'Presentations', icon: Presentation, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'ESTIMATOR'] },
  { to: '/schedule', label: 'Schedule', icon: Calendar, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'FIELD_LEAD', 'JOB_LEAD'] },
  { to: '/billing', label: 'Billing', icon: Receipt, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'FIELD_LEAD', 'JOB_LEAD'] },
  { to: '/field', label: 'Field', icon: HardHat, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'FIELD_LEAD'] },
  { to: '/performance', label: 'Performance', icon: TrendingUp, roles: ['OWNER', 'ADMIN', 'JOB_MANAGER', 'ESTIMATOR', 'FIELD_LEAD'] },
  { to: '/settings/team', label: 'Team', icon: UserCog, roles: ['OWNER', 'ADMIN'] },
  { to: '/settings/profit', label: 'Profit', icon: PiggyBank, roles: ['OWNER', 'ADMIN'] },
];

export function visibleNavItems(role: EmployeeRole | undefined): NavItem[] {
  return NAV_ITEMS.filter((item) => !item.roles || (role && item.roles.includes(role)));
}
